import { format, isToday, isYesterday } from 'date-fns';
import { es } from 'date-fns/locale';

const COUNTRY_TIMEZONE = {
  CL: "America/Santiago",
  PE: "America/Lima",
  MX: "America/Mexico_City",
  CO: "America/Bogota",
  AR: "America/Argentina/Buenos_Aires",
  PA: "America/Panama",
  EC: "America/Guayaquil",
  US: "America/New_York",
  BR: "America/Sao_Paulo",
  ES: "Europe/Madrid",
  SV: "America/El_Salvador",
  UY: "America/Montevideo",
};

const hasCountryTimezone = (countryCode) => {
  return countryCode && COUNTRY_TIMEZONE[countryCode] !== undefined;
};

export const formatDateWithCountryCode = (dateString, countryCode) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const currentDate = new Date(date);
  currentDate.setHours(0, 0, 0, 0);

  const tz = hasCountryTimezone(countryCode)
    ? COUNTRY_TIMEZONE[countryCode]
    : "UTC";
  const time = new Date(date).toLocaleTimeString("en-US", {
    timeZone: tz,
    hour: "2-digit",
    minute: "2-digit",
  });

  if (currentDate.getTime() === today.getTime()) return `Hoy ${time}`;
  if (currentDate.getTime() === yesterday.getTime()) return `Ayer ${time}`;
  return `${format(new Date(date), "dd/MMM")} ${time}`;
}